export enum SiteTypes {
  ADMIN_PANEL_SITE = "adminPanelSite",
  INCIDENT_SITE = "incidentSite",
  ASSOCIATE_HOME_SITE = "associateHomeSite",
  ALL_CLAIM_SITES = "allClaimSites",
  DOCUMENTS_PAGE_SITE = "documentsPageSite",
}
